import { SIGN_IN, SIGN_OUT, SET_NAME, SET_EMAIL, SET_LOADING, SET_ROLE, SET_ADMIN, SET_APPROVER, SET_EDITOR, SET_BOOK_GROUP } from './types';

export const signIn = () => {
    return {
        type: SIGN_IN
    }
}

export const signOut = () => {
    return {
        type: SIGN_OUT
    }
}

export const setName = (name) => {
    return {
        type: SET_NAME,
        payload: name
    }
}

export const setEmail = (email) => {
    return {
        type: SET_EMAIL,
        payload: email
    }
}

export const setLoading = (isLoading) => {
    return {
        type: SET_LOADING,
        payload: isLoading
    }
}

export const setRole = (role) => {
    return {
        type: SET_ROLE,
        payload: role
    }
}

export const setAdmin = (v) => {
    return {
        type: SET_ADMIN,
        payload: v
    }
}

export const setApprover = (v) => {
    return {
        type: SET_APPROVER,
        payload: v
    }
}

export const setEditor = (v) => {
    return {
        type: SET_EDITOR,
        payload: v
    }
}

export const setBookGroup = (v) => {
    return {
        type: SET_BOOK_GROUP,
        payload: v
    }
}